import { Dayjs } from 'dayjs'

export const camelize = (str: string) => {
  const safeStr = str || ''
  return safeStr.replace(
    /(?:^\w|[A-Z]|\b\w|\s+)/g,
    function (match: string, index: number) {
      if (+match === 0) return ''
      return index === 0 ? match.toLowerCase() : match.toUpperCase()
    },
  )
}

export function sanitizeSlug(slug: string) {
  return slug.replace(/[^a-zA-Z0-9-]/g, '')
}

export const capitalize = (str: string) => {
  if (!str) return ''
  const safeStr = str || ''
  const fistLetter = safeStr[0]
  const restLetter = safeStr.slice(1, safeStr.length)
  return `${fistLetter}${restLetter.toLowerCase()}`
}

export const formatDurations = (val: number) => {
  if (val < 60) return `${val}min`
  const min = val % 60
  const hours = Math.floor(val / 60)
  if (!min) {
    return `${hours}h`
  }
  return `${hours}h ${min}min`
}

export const timeFormat = (val: number) => {
  if (val < 60) return `00:${val < 10 ? `0${val}` : val}`
  const min = val % 60
  const hours = Math.floor(val / 60)

  return `${hours < 10 ? `0${hours}` : hours}:${min < 10 ? `0${min}` : min}`
}

export const getInitial = (val: string | null | undefined) => {
  if (val) {
    const splited = val.split(' ')
    let result = ''
    if (splited[0]) result += splited[0][0]
    if (splited[1]) result += splited[1][0]
    return result.toUpperCase()
  }
  return ''
}

export const daysOfWeek = (day: Dayjs) => {
  return [
    {
      label: 'Mon',
      amount: 0,
      dayInstance: day.day(1),
    },
    {
      label: 'Tue',
      amount: 0,
      dayInstance: day.day(2),
    },
    {
      label: 'Wed',
      amount: 0,
      dayInstance: day.day(3),
    },
    {
      label: 'Thu',
      amount: 0,
      dayInstance: day.day(4),
    },
    {
      label: 'Fri',
      amount: 0,
      dayInstance: day.day(5),
    },
    {
      label: 'Sat',
      amount: 0,
      dayInstance: day.day(6),
    },
    {
      label: 'Sun',
      amount: 0,
      dayInstance: day.day(6).add(1, 'day'),
    },
  ]
}

export const formatPhoneNumberMark = (phoneNumber: string) => {
  return phoneNumber.replaceAll(' ', '').replace(/(\d{4})(?=\d)/g, '$1-')
}

export function uuidToReadableColor(uuid: string, opacity = 1) {
  let hash = 0
  for (let i = 0; i < uuid.length; i++) {
    hash = uuid.charCodeAt(i) + ((hash << 5) - hash)
    hash |= 0
  }

  const r = (hash >> 16) & 0xff
  const g = (hash >> 8) & 0xff
  const b = hash & 0xff

  const mix = 0.5
  const finalR = Math.floor(r * mix + 255 * (1 - mix))
  const finalG = Math.floor(g * mix + 255 * (1 - mix))
  const finalB = Math.floor(b * mix + 255 * (1 - mix))

  // Pastikan opacity tetap di
  const alpha = Math.max(0, Math.min(1, opacity))

  return `rgba(${finalR}, ${finalG}, ${finalB}, ${alpha})`
}

export function softenColor(hex: string, strength: number = 0.4): string {
  // validasi format
  if (!/^#?[0-9a-fA-F]{6}$/.test(hex)) {
    throw new Error('Hex color harus format #RRGGBB')
  }

  const normalized = hex.replace('#', '')

  const r = parseInt(normalized.slice(0, 2), 16)
  const g = parseInt(normalized.slice(2, 4), 16)
  const b = parseInt(normalized.slice(4, 6), 16)

  // clamp strength 0..1
  const s = Math.min(1, Math.max(0, strength))

  const mix = (channel: number): number =>
    Math.round(channel + (255 - channel) * s)

  const toHex = (value: number): string => value.toString(16).padStart(2, '0')

  return `#${toHex(mix(r))}${toHex(mix(g))}${toHex(mix(b))}`
}

export const getBirthdayStatus = (
  todayDate: Dayjs,
  birthDate: Dayjs,
): {
  isBirthdayToday: boolean
  isBirthdayPeriod: boolean
  birthdayStatus: 'today' | 'upcoming' | 'recent' | 'none'
  diff: number
} => {
  let birthday = birthDate.tz('Asia/Jakarta').year(todayDate.year())

  // handle edge case tahun baru (Dec → Jan)
  if (birthday.isBefore(todayDate.subtract(7, 'day'))) {
    birthday = birthday.add(1, 'year')
  }

  const diff = birthday.startOf('day').diff(todayDate.startOf('day'), 'day')
  const isBirthdayToday = diff === 0
  const isBirthdayPeriod = Math.abs(diff) <= 7

  let birthdayStatus: 'today' | 'upcoming' | 'recent' | 'none' = 'none'

  if (diff === 0) {
    birthdayStatus = 'today'
  } else if (diff > 0) {
    birthdayStatus = 'upcoming'
  } else if (diff < 0) {
    birthdayStatus = 'recent'
  }
  return {
    isBirthdayToday,
    isBirthdayPeriod,
    birthdayStatus,
    diff: Math.abs(diff),
  }
}
